import RecipientFeedRow, { type RecipientFeed } from "@/components/RecipientFeedRow";
import VirtualizedSelectList from "@/components/VirtualizedSelectList";

/** Initial row-height estimate; rows with command-alias chips are taller, but real heights get measured. */
const ROW_ESTIMATE_PX = 44;

/**
 * Renders a fleet-message recipient list, virtualizing large lists so a single group with thousands
 * of channels doesn't freeze the picker. See {@link VirtualizedSelectList}.
 */
export default function RecipientFeedList({
  id,
  feeds,
  activeChannels,
  toggleSingleFeed,
}: {
  id: string;
  feeds: RecipientFeed[];
  activeChannels: string[];
  toggleSingleFeed: (id: string) => void;
}) {
  return (
    <VirtualizedSelectList
      id={id}
      items={feeds}
      itemSize={ROW_ESTIMATE_PX}
      renderRow={(feed) => (
        <RecipientFeedRow feed={feed} active={activeChannels?.includes(feed.id)} onToggle={toggleSingleFeed} />
      )}
    />
  );
}
